(() => {
  const shell = document.querySelector('[data-search-results-page-shell]');
  const placeholder = shell?.querySelector('[data-search-results-page-placeholder]');
  const component = shell?.querySelector('eb-search-component');
  if (!shell || !placeholder || !component) return;

  const showComponent = () => {
    const shadowContent = component.shadowRoot?.querySelector('div');
    if (!shadowContent || shadowContent.childElementCount === 0) return false;
    component.style.display = 'block';
    placeholder.hidden = true;
    return true;
  };

  const watcher = setInterval(() => {
    if (showComponent()) clearInterval(watcher);
  }, 50);

  setTimeout(() => {
    clearInterval(watcher);
    showComponent();
  }, 8000);
})();
